/** @jsxImportSource @emotion/react */
import { useMemo, useRef } from 'react';

import Map from '../MapPageService';

const ProvidersMap = ({
  data,
  userLocation,
  handleSelect,
  selectedId,
  handleMapMovement,
  scrollToCard,
  momappage = false,
}) => {
  const idref = useRef();

  const pushPins = useMemo(
    () =>
      data.map(
        ({
          ClubId,
          CentreId,
          Longitude,
          Latitude,
          MapPinId,
          PinClusterCount,
          PinClusterIndex,
          ProviderCartDto,
          PitchFinderId,
          SessionCartDto,
        }) => {
          ProviderCartDto?.map(providerdetails => {
            if (!SessionCartDto && ProviderCartDto?.length < 2) {
              idref.current = providerdetails.ProviderId;
            }
            return providerdetails;
          });
          const recommendationId = ClubId
            ? ClubId
            : CentreId && !momappage
            ? CentreId
            : idref.current && !momappage
            ? idref.current
            : PitchFinderId;
          const id = MapPinId || recommendationId;
          return {
            id,
            longitude: Longitude,
            latitude: Latitude,
            clusterCount:
              PinClusterIndex === 0 && PinClusterCount > 1
                ? PinClusterCount
                : undefined,
            handleClick: () => {
              if (id) {
                handleSelect(id);
                scrollToCard?.(id);
              }
            },
          };
        }
      ),
    [data, handleSelect, momappage, scrollToCard]
  );

  return (
    <Map
      pushPins={pushPins}
      mapOptions={{
        center: userLocation,
        handleMapMovement,
      }}
      selectedId={selectedId}
    />
  );
};

export default ProvidersMap;
